import type { DanceSeoHead } from "../danceSeoTypes.js";

// id translation of the English source (shared/danceSeoHeads/en.ts); numbers and limits must stay in sync with it.
const head: DanceSeoHead = {
  director: {
    title: "Generator Video Dance AI dari Lagu — Mulai Gratis",
    description:
      "Ubah lagu apa pun jadi video dance AI utuh. Solmi merencanakan koreografi tiap bagian, membuat storyboard, lalu merender shot dance dan lip-sync. Mulai gratis.",
    h1: "Generator Video Dance AI — Ubah Lagu Apa Pun Menjadi Video Dance",
  },
  photo: {
    title: "Buat Foto Menari dengan AI — Foto Jadi Joget | Solmi",
    description:
      "Buat foto menari dengan AI: unggah foto seluruh badan, pilih gerakan atau klipmu sendiri, tambahkan lagu. Solmi menyelaraskan gerakan dengan beat. Mulai gratis.",
    h1: "Buat Foto Menari — Generator Dance AI dari Foto",
  },
  inbound:
    "Ingin performernya menari? [Generator video dance AI](/ai-dance-video-generator) merencanakan koreografi untuk setiap bagian lagumu dan merender video dance utuh.",
};

export default head;
